<app-base-dialog sizeClass="size-18" [topBarTemplate]="topBar" [bottomBarRightTemplate]="bottomBar">
	<ng-template #topBar>
		<app-dialog-header title="Opslaan als favoriet"></app-dialog-header>
	</ng-template>
	<div class="container">
		<div class="label">
			<span>Naam </span>
			<span class="required-icon">*</span>
		</div>
		<input #inp [required]="true" type="text" (input)="naam.set(inp.value)" [value]="naam()" (keyup.enter)="close()" />
	</div>
	<ng-template #bottomBar>
		<app-button buttonType="secondary" (clickit)="dialogRef.close()">Annuleren</app-button>
		<app-button [enabled]="notEmpty()" (clickit)="dialogRef.close(naam())">Opslaan</app-button>
	</ng-template>
</app-base-dialog>
